import uuid from 'react-uuid';

export const getDeviceId = () => {
  try {
    var storage = window.localStorage || window.sessionStorage;
    if (storage) {
      var deviceId = storage.getItem('deviceId');
      if (!deviceId) {
        deviceId = uuid();
        storage.setItem('deviceId', deviceId);
      }
      return deviceId;
    } else {
      return uuid();
    }
  } catch (e) {
    return uuid();
  }
};

export const getSessionId = () => {
  try {
    var storage = window.sessionStorage;
    if (storage) {
      var sessionId = storage.getItem('sessionId');
      if (!sessionId) {
        sessionId = uuid();
        storage.setItem('sessionId', sessionId);
      }
      return sessionId;
    } else {
      return uuid();
    }
  } catch (e) {
    return uuid();
  }
};

export const localStorageClear = (obj) => {
  try {
    if (obj === undefined) {
      localStorage.clear();
    } else {
      let storageObj = localStorage.getItem('cellcomUserStorage');
      if (!Array.isArray(obj)) {
        delete storageObj[obj.toString()];
      } else {
        obj.forEach((key) => {
          delete storageObj[key.toString()];
        });
      }
      lsaSet(storageObj);
    }
  } catch (err) {
    return false;
  }
  return true;
};
